import React from "react";
import {
  BoxButton,
  Typography,
} from "@trussle/external-components";
import "./styles.scss";
import { Link } from "gatsby";
import { ISplashPanelProps } from "../OriginalSplashPanel";
import { generateId } from "../../../../helpers/generateId";
import { ReplaceQueryParams } from "../../../ReplaceQueryParams";
import { PanelWrapper } from "../../../PanelWrapper";

export const HorizontalBoxButtonsSplashPanel: React.FunctionComponent<
  ISplashPanelProps
> = ({
  title, ctas,
}) => (
  <PanelWrapper>
    {title && (
      <Typography
        classes="horizontalBoxButtonSplashPanel__title"
        variant="h5"
        {...(title && {
          id: generateId(title),
        })}
      >
        <ReplaceQueryParams>{title}</ReplaceQueryParams>
      </Typography>
    )}
    <div className="horizontalBoxButtonSplashPanel--horizontalBoxButtons">
      { ctas?.map((button) => (
        <Link key={button.title} to={button.url} className="horizontalBoxButtonSplashPanel--link">
          <BoxButton text={button.title} label={button.subtitle || undefined} />
        </Link>
      )) }
    </div>
  </PanelWrapper>
);
